import React from 'react'
import { usePracticeInterviewing } from './PracticeInterviewingProvider'
import { Button } from '~/lib/ui/button'
import Spinner, { SpinnerWhite } from '../shared/Spinner'
import Questions from './Questions'
import PracticeInterviewResponses from './PracticeInterviewResponses'
import { useTranslation } from '../../hooks/useTranslation'
import AylaLoading from '../shared/AylaLoading'

const PracticeInterviewQuestions = () => {
  const { uiState } = usePracticeInterviewing()
  const { generatingInterview, aiInterview, showInterview, showResponses } =
    uiState

  return (
    <div className="flex w-full flex-row rounded-2xl bg-lily-blue px-4 py-8 text-primary md:m-8">
      {generatingInterview && <LoadingScreen aiInterview={aiInterview} />}
      {showInterview && <Questions />}
      {showResponses && <PracticeInterviewResponses />}
    </div>
  )
}

const LoadingScreen = ({ aiInterview }) => {
  const { t } = useTranslation('PracticeInterviewQuestions')
  return (
    <div className="flex w-full flex-col">
      <h2 className="mb-4">{t('title')}</h2>
      <p className="mb-8">
        {aiInterview ? t('description') : t('general_description')}
      </p>
      <div className="h-full w-full">
        <div className="flex items-center justify-center">
          {aiInterview ? (
            <AylaLoading />
          ) : (
            <Spinner show={true} className="mx-auto my-10 w-20" />
          )}
        </div>
      </div>
      <div className="w-full text-right">
        <Button>
          {t('generating')}{' '}
          <SpinnerWhite show={true} className="mt-2 h-8 w-8 pl-2" />
        </Button>
      </div>
    </div>
  )
}

export default PracticeInterviewQuestions
